import Dashboard from "../../components/Dashboard/Dashboard";
import {Assignment, EmojiEvents, Equalizer, Message, Settings} from "@material-ui/icons";
import React from "react";
import {Container, Typography} from "@material-ui/core";
import UserList from "../../components/UserList/UserList";
import TaskList from "../../components/TaskList/TaskList";
import {createStyles, makeStyles, Theme} from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            backgroundColor: theme.palette.background.paper,
            padding: '0 0'
        },
    }),
)

const KidBoard = () => {
    const menu = [
        {title: 'Tasks', icon: <Assignment/>, link: '/posts'},
        {title: 'Prizes', icon: <EmojiEvents/>, link: '/mailing'},
        {title: 'Send message', icon: <Message/>, link: '/sendmsg'},
        {title: 'Stats', icon: <Equalizer/>, link: '/mailing'},
        {title: 'Settings', icon: <Settings/>, link: '/settings'},
    ]
    const classes = useStyles();
    return (
        <div>
            <Dashboard menu={menu}>
                <Container maxWidth="xl" className={classes.root}>
                    <Typography variant={'h4'}>
                        Tasks
                    </Typography>
                    <TaskList/>
                </Container>
            </Dashboard>
        </div>
    );
};

export default KidBoard;
